import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { WhyItFailed } from '../components/WhyItFailed';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoItsFor } from '../components/WhoItsFor';
import { HowItWorks } from '../components/HowItWorks';
import { SocialProof } from '../components/SocialProof';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-slate-900 text-slate-50 font-sans selection:bg-blue-500/30" data-id="element-233">
      <Hero data-id="element-234" />
      <ProblemSection data-id="element-235" />
      <WhyItFailed data-id="element-236" />
      <UniqueMechanism data-id="element-237" />
      <WhatYouGet data-id="element-238" />
      <WhoItsFor data-id="element-239" />
      <HowItWorks data-id="element-240" />
      <SocialProof data-id="element-241" />
      <FAQSection data-id="element-242" />
      <PricingSection data-id="element-243" />

      <Footer data-id="element-244" />
    </main>;
}